// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer {
  display: flex;
  max-width: 1386px;
  margin: 0 auto 200px auto;
  position: relative;
}

.offer__info-container {
  display: flex;
  flex-direction: column;
  margin: 68px 0px 289px 0px;
}

.offer__job {
  max-width: 479px;
  font-family: "Playfair Display";
  font-size: 40px;
  font-weight: 400;
  font-style: italic;
  line-height: 50px;
  margin: 0 0 56px 0;
  padding: 0;
}

.offer__name {
  max-width: 692px;
  font-size: 72px;
  font-weight: 600;
  line-height: 83px;
  font-family: "Playfair Display";
  font-weight: 600;
  margin: 0px 7px 56px 0;
  padding: 0;
}

.offer__about {
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  max-width: 463px;
  margin: 0 0 94px 0;
  padding: 0;
}

.offer__button {
  width: 460px;
  height: 116px;
  background-color: rgba(144, 110, 103, 1);
  border-radius: 20px;
  border: none;
  color: white;
  text-align: center;
  font-size: 20px;
  line-height: 116px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
}

.offer__button:hover {
  background-color: rgb(147, 120, 114);
}

.offer__photo {
  max-width: 734px;
  max-height: 1099px;
  border-radius: 10px;
}

@media screen and (max-width: 1439px) {
  .offer {
    max-width: 984px;
    margin: 0 auto 100px auto;
  }

  .offer__info-container {
    margin: 68px 40px 0px 0px;
  }

  .offer__job {
    max-width: 288px;
    font-size: 24px;
    line-height: 30px;
    margin: 0 0 46px 0;
  }

  .offer__name {
    font-size: 40px;
    line-height: 50px;
    margin: 0px 7px 46px 0;
  }

  .offer__about {
    max-width: 410px;
    margin: 0 0 46px 0;
    padding: 0;
  }

  .offer__button {
    width: 287px;
    height: 85px;
    font-size: 18px;
    line-height: 85px;
  }

  .offer__photo {
    width: 388px;
    height: 580px;
  }
}

@media screen and (max-width: 1023px) {
  .offer {
    max-width: 708px;
    margin: 0 auto 75px auto;
  }

  .offer__info-container {
    margin: auto 20px auto 0px;
  }

  .offer__job {
    max-width: 288px;
    font-size: 21px;
    line-height: 26px;
    margin: 0 0 30px 0;
  }

  .offer__name {
    font-size: 33px;
    line-height: 45px;
    margin: 0px 0px 30px 0;
  }

  .offer__about {
    font-size: 18px;
    line-height: 25px;
    margin: 0 0 30px 0;
  }
}

@media screen and (max-width: 763px) {
  .offer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 322px;
    margin: 0 auto 132px auto;
  }

  .offer__info-container {
    justify-content: center;
    align-items: center;
    margin: 0px;
  }

  .offer__job {
    max-width: 229px;
    text-align: center;
    font-size: 25px;
    line-height: 35px;
    margin: 0 0 8px 0;
    padding: 0;
  }

  .offer__name {
    max-width: 330px;
    text-align: center;
    font-size: 37px;
    line-height: 47px;
    margin: 0px 0px 31px 0;
    padding: 0;
  }

  .offer__about {
    max-width: 247px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 33px 0;
  }

  .offer__button {
    width: 260px;
    height: 75px;
    border: none;
    font-size: 16px;
    line-height: 75px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s;
  }

  .offer__photo {
    aspect-ratio: 1;
    max-width: 330px;
    max-height: 330px;
    object-fit: cover;
    margin: 0 0 61px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Offer/Offer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".offer {\r\n  display: flex;\r\n  max-width: 1386px;\r\n  margin: 0 auto 200px auto;\r\n  position: relative;\r\n}\r\n\r\n.offer__info-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 68px 0px 289px 0px;\r\n}\r\n\r\n.offer__job {\r\n  max-width: 479px;\r\n  font-family: \"Playfair Display\";\r\n  font-size: 40px;\r\n  font-weight: 400;\r\n  font-style: italic;\r\n  line-height: 50px;\r\n  margin: 0 0 56px 0;\r\n  padding: 0;\r\n}\r\n\r\n.offer__name {\r\n  max-width: 692px;\r\n  font-size: 72px;\r\n  font-weight: 600;\r\n  line-height: 83px;\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 600;\r\n  margin: 0px 7px 56px 0;\r\n  padding: 0;\r\n}\r\n\r\n.offer__about {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 30px;\r\n  max-width: 463px;\r\n  margin: 0 0 94px 0;\r\n  padding: 0;\r\n}\r\n\r\n.offer__button {\r\n  width: 460px;\r\n  height: 116px;\r\n  background-color: rgba(144, 110, 103, 1);\r\n  border-radius: 20px;\r\n  border: none;\r\n  color: white;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  line-height: 116px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.offer__button:hover {\r\n  background-color: rgb(147, 120, 114);\r\n}\r\n\r\n.offer__photo {\r\n  max-width: 734px;\r\n  max-height: 1099px;\r\n  border-radius: 10px;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .offer {\r\n    max-width: 984px;\r\n    margin: 0 auto 100px auto;\r\n  }\r\n\r\n  .offer__info-container {\r\n    margin: 68px 40px 0px 0px;\r\n  }\r\n\r\n  .offer__job {\r\n    max-width: 288px;\r\n    font-size: 24px;\r\n    line-height: 30px;\r\n    margin: 0 0 46px 0;\r\n  }\r\n\r\n  .offer__name {\r\n    font-size: 40px;\r\n    line-height: 50px;\r\n    margin: 0px 7px 46px 0;\r\n  }\r\n\r\n  .offer__about {\r\n    max-width: 410px;\r\n    margin: 0 0 46px 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .offer__button {\r\n    width: 287px;\r\n    height: 85px;\r\n    font-size: 18px;\r\n    line-height: 85px;\r\n  }\r\n\r\n  .offer__photo {\r\n    width: 388px;\r\n    height: 580px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .offer {\r\n    max-width: 708px;\r\n    margin: 0 auto 75px auto;\r\n  }\r\n\r\n  .offer__info-container {\r\n    margin: auto 20px auto 0px;\r\n  }\r\n\r\n  .offer__job {\r\n    max-width: 288px;\r\n    font-size: 21px;\r\n    line-height: 26px;\r\n    margin: 0 0 30px 0;\r\n  }\r\n\r\n  .offer__name {\r\n    font-size: 33px;\r\n    line-height: 45px;\r\n    margin: 0px 0px 30px 0;\r\n  }\r\n\r\n  .offer__about {\r\n    font-size: 18px;\r\n    line-height: 25px;\r\n    margin: 0 0 30px 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .offer {\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 322px;\r\n    margin: 0 auto 132px auto;\r\n  }\r\n\r\n  .offer__info-container {\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 0px;\r\n  }\r\n\r\n  .offer__job {\r\n    max-width: 229px;\r\n    text-align: center;\r\n    font-size: 25px;\r\n    line-height: 35px;\r\n    margin: 0 0 8px 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .offer__name {\r\n    max-width: 330px;\r\n    text-align: center;\r\n    font-size: 37px;\r\n    line-height: 47px;\r\n    margin: 0px 0px 31px 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .offer__about {\r\n    max-width: 247px;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    margin: 0 0 33px 0;\r\n  }\r\n\r\n  .offer__button {\r\n    width: 260px;\r\n    height: 75px;\r\n    border: none;\r\n    font-size: 16px;\r\n    line-height: 75px;\r\n    text-transform: uppercase;\r\n    cursor: pointer;\r\n    transition: all 0.3s;\r\n  }\r\n\r\n  .offer__photo {\r\n    aspect-ratio: 1;\r\n    max-width: 330px;\r\n    max-height: 330px;\r\n    object-fit: cover;\r\n    margin: 0 0 61px 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
